export const COMPONENT_TYPES = {
  TEXT: "TEXT",
  IMAGE: "IMAGE",
  CONTAINER: "CONTAINER",
  BUTTON: "BUTTON",
  LOGIN: "LOGIN",
  BOARD: "BOARD",
  ROW: "ROW",
  COLUMN: "COLUMN",
  PRODUCT_DETAIL: "PRODUCT_DETAIL",
  PRODUCT_LIST: "PRODUCT_LIST",
  PRODUCT_SLIDER: "PRODUCT_SLIDER",
  IMAGE_SLIDER: "IMAGE_SLIDER",
  SIGNUP: "SIGNUP",
  MAIN_BANNER: "MAIN_BANNER",
  CART: "CART",
  PAYMENT: "PAYMENT",
  PAYLETTER_PAYMENT: "PAYLETTER_PAYMENT",
  PAYMENT_SUCCESS: "PAYMENT_SUCCESS",
  PAYMENT_FAIL: "PAYMENT_FAIL",
  PAYLETTER_SUCCESS: "PAYLETTER_SUCCESS",
  PAYLETTER_FAIL: "PAYLETTER_FAIL",
  FAQ: "FAQ",
  ORDER_HISTORY: "ORDER_HISTORY",
  COMPANY_HISTORY: "COMPANY_HISTORY",
  ASSET_HISTORY: "ASSET_HISTORY",
  MEMBERSHIP_SIGNUP: "MEMBERSHIP_SIGNUP",
  CUSTOM_MEMBERSHIP_SIGNUP: "CUSTOM_MEMBERSHIP_SIGNUP",
  BINARY_LEGS: "BINARY_LEGS",
  UNILEVEL_LEGS: "UNILEVEL_LEGS",
  RICH_EDITOR: "RICH_EDITOR",
  USER_PROFILE: "USER_PROFILE",
  IMAGE_TEXT: "IMAGE_TEXT",
  TRENDING_ITEMS: "TRENDING_ITEMS",
  FIXED_BG_TEXT: "FIXED_BG_TEXT",
  REVIEW_FORM: "REVIEW_FORM",
  TAB_LAYOUT: "TAB_LAYOUT",
  DETAIL_PAGE: "DETAIL_PAGE",
  PARALLAX: "PARALLAX",
  BENEFIT_SUMMARY: "BENEFIT_SUMMARY",
  RECOMMENDED_USERS: "RECOMMENDED_USERS",
  MOBILE_LAYOUT: "MOBILE_LAYOUT"
};

// 메뉴 타입 상수
export const MENU_TYPES = {
  GLOBAL: "GLOBAL",
  MAIN: "MAIN"
};

// COMPONENT_TYPES 문자열 상수 내보내기 - 타입 참조용
export const TEXT = COMPONENT_TYPES.TEXT;
export const IMAGE = COMPONENT_TYPES.IMAGE;
export const CONTAINER = COMPONENT_TYPES.CONTAINER;
export const BUTTON = COMPONENT_TYPES.BUTTON;
export const LOGIN = COMPONENT_TYPES.LOGIN;
export const BOARD = COMPONENT_TYPES.BOARD;
export const DETAIL_PAGE = COMPONENT_TYPES.DETAIL_PAGE;
export const ROW = COMPONENT_TYPES.ROW;
export const COLUMN = COMPONENT_TYPES.COLUMN;
export const PRODUCT_DETAIL = COMPONENT_TYPES.PRODUCT_DETAIL;
export const PRODUCT_LIST = COMPONENT_TYPES.PRODUCT_LIST;
export const PRODUCT_SLIDER = COMPONENT_TYPES.PRODUCT_SLIDER;
export const IMAGE_SLIDER = COMPONENT_TYPES.IMAGE_SLIDER;
export const SIGNUP = COMPONENT_TYPES.SIGNUP;
export const MAIN_BANNER = COMPONENT_TYPES.MAIN_BANNER;
export const CART = COMPONENT_TYPES.CART;
export const PAYMENT = COMPONENT_TYPES.PAYMENT;
export const PAYLETTER_PAYMENT = COMPONENT_TYPES.PAYLETTER_PAYMENT;
export const PAYMENT_SUCCESS = COMPONENT_TYPES.PAYMENT_SUCCESS;
export const PAYMENT_FAIL = COMPONENT_TYPES.PAYMENT_FAIL;
export const PAYLETTER_SUCCESS = COMPONENT_TYPES.PAYLETTER_SUCCESS;
export const PAYLETTER_FAIL = COMPONENT_TYPES.PAYLETTER_FAIL;
export const FAQ = COMPONENT_TYPES.FAQ;
export const ORDER_HISTORY = COMPONENT_TYPES.ORDER_HISTORY;
export const COMPANY_HISTORY = COMPONENT_TYPES.COMPANY_HISTORY;
export const MILEAGE_HISTORY = COMPONENT_TYPES.MILEAGE_HISTORY;
export const MEMBERSHIP_SIGNUP = COMPONENT_TYPES.MEMBERSHIP_SIGNUP;
export const CUSTOM_MEMBERSHIP_SIGNUP = COMPONENT_TYPES.CUSTOM_MEMBERSHIP_SIGNUP;
export const BINARY_LEGS = COMPONENT_TYPES.BINARY_LEGS;
export const RICH_EDITOR = COMPONENT_TYPES.RICH_EDITOR;
export const USER_PROFILE = COMPONENT_TYPES.USER_PROFILE;
export const IMAGE_TEXT = COMPONENT_TYPES.IMAGE_TEXT;
export const TRENDING_ITEMS = COMPONENT_TYPES.TRENDING_ITEMS;
export const FIXED_BG_TEXT = COMPONENT_TYPES.FIXED_BG_TEXT;
export const REVIEW_FORM = COMPONENT_TYPES.REVIEW_FORM;
export const TAB_LAYOUT = COMPONENT_TYPES.TAB_LAYOUT;
export const PARALLAX = COMPONENT_TYPES.PARALLAX;
export const BENEFIT_SUMMARY = COMPONENT_TYPES.BENEFIT_SUMMARY;
export const RECOMMENDED_USERS = COMPONENT_TYPES.RECOMMENDED_USERS;
export const MOBILE_LAYOUT = COMPONENT_TYPES.MOBILE_LAYOUT;

// MENU_TYPES 문자열 상수 내보내기
export const GLOBAL = MENU_TYPES.GLOBAL;
export const MAIN = MENU_TYPES.MAIN;
